import { useState } from "react";
import axios from "axios";

export default function ImportDailyCall() {
    const [file, setFile] = useState(null);
    const [data, setData] = useState([]);
    const [summary, setSummary] = useState(null);

    const [page, setPage] = useState(1);
    const rowsPerPage = 10;

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleValidate = async () => {
        if (!file) {
            alert("Please select a file");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        try {
            const res = await axios.post(
                "https://localhost:7172/api/import/validate-daily-call",
                formData
            );

            setData(res.data.data);
            setSummary(res.data);
            setPage(1);
        } catch (err) {
            console.error(err);
            alert("Error validating file");
        }
    };

    const handleImport = async () => {
        if (!file) {
            alert("Please select a file");
            return;
        }

        console.log("Import clicked");

        const formData = new FormData();
        formData.append("file", file);

        try {
            const res = await axios.post(
                "https://localhost:7172/api/import/import-daily-call",
                formData
            );

            alert(`Inserted: ${res.data.inserted}, Skipped: ${res.data.skipped}`);

        } catch (err) {
            console.error(err);
            alert("Error importing data");
        }
    };

    // Pagination
    const startIndex = (page - 1) * rowsPerPage;
    const paginatedData = data.slice(startIndex, startIndex + rowsPerPage);
    const totalPages = Math.ceil(data.length / rowsPerPage);

    return (
        <div>

            {/* HEADER */}
            <div style={{
                background: "#2f3542",
                color: "#fff",
                padding: "12px 15px",
                borderRadius: "6px",
                fontWeight: "bold",
                marginBottom: "15px",
                fontSize: "14px"
            }}>
                Import Daily Call Register
            </div>

            {/* ACTION BAR */}
            <div style={{ marginBottom: "10px" }}>
                <input
                    type="file"
                    id="fileUpload"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                />

                <label htmlFor="fileUpload" style={styles.button}>
                    Choose File
                </label>

                <span style={{ marginLeft: "10px" }}>
                    {file ? file.name : "No file chosen"}
                </span>
                <button onClick={handleValidate} style={styles.button}>Validate</button>
                <button
                    onClick={handleImport}
                    disabled={!summary}
                    style={{
                        ...styles.button,
                        background: summary ? "#2ed573" : "#ccc",
                        cursor: summary ? "pointer" : "not-allowed"
                    }}
                >
                    Import
                </button>
            </div>

            {/* SUMMARY */}
            {summary && (
                <div style={styles.summary}>
                    <span>Total: {summary.total}</span>
                    <span>Valid: {summary.valid}</span>
                    <span style={{ color: "red" }}>Errors: {summary.errors}</span>
                </div>
            )}

            {/* TABLE */}
            <table style={styles.table}>
                <thead>
                    <tr>
                        <th style={styles.th}>Employee</th>
                        <th style={styles.th}>Customer</th>
                        <th style={styles.th}>Contact</th>
                        <th style={styles.th}>Status</th>
                        <th style={styles.th}>Error</th>
                    </tr>
                </thead>
                <tbody>
                    {paginatedData.map((row, i) => (
                        <tr key={i}>
                            <td style={styles.td}>{row.employeeName}</td>
                            <td style={styles.td}>{row.customerName}</td>
                            <td style={styles.td}>{row.contactNumber}</td>
                            <td style={styles.td}>{row.status}</td>
                            <td style={{ ...styles.td, color: "red" }}>{row.error}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* PAGINATION */}
            {data.length > 0 && (
                <div style={styles.pagination}>
                    <button disabled={page === 1} onClick={() => setPage(page - 1)}>Prev</button>
                    <span> Page {page} of {totalPages} </span>
                    <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>Next</button>
                </div>
            )}

        </div>
    );
}

const styles = {
    button: {
        marginLeft: "10px",
        padding: "6px 12px",
        border: "none",
        borderRadius: "4px",
        background: "#1e90ff",
        color: "#fff",
        cursor: "pointer",
        fontSize: "12px"
    },
    summary: {
        margin: "10px 0",
        display: "flex",
        gap: "20px",
        fontWeight: "bold"
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "10px"
    }, 
    pagination: {
        marginTop: "10px",
        textAlign: "center"
    },
    th: {
        border: "1px solid #ccc",
        padding: "8px",
        background: "#f1f2f6",
        textAlign: "left"
    },
    td: {
        border: "1px solid #ccc",
        padding: "8px"
    }
};